import create from 'zustand'
import { persist } from "zustand/middleware"

const persistConfig = {
  name: "register-with-google-callback"
};

const registerWithGoogleCallbackStore = create(persist((set, get) => {

  const setSuccessPathAction = async (successPath) => {
    set({ successPath })
  }

  const setDataAction = async (googleId, accessToken, email, firstname, lastname) => {
    const data = {
      googleId, accessToken, email, firstname, lastname
    }
    set({ data })
  }

  const clearAllAction = () => set({
    ...initState
  })

  const initState = {
    successPath: null,
    data: null,
  }
  
  return {
    ...initState,
    setSuccessPath: setSuccessPathAction,
    setData: setDataAction,
    clearAll: clearAllAction,
  }
}, persistConfig));

export default registerWithGoogleCallbackStore;